module.exports = __webpack_public_path__ + "img/classics31.753b04a.jpg";